import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Briefcase, Building2, Heart, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const pathways = [
  {
    icon: Briefcase,
    title: "Job Seekers",
    description: "Build your resume, showcase your skills, and connect with second-chance employers who value your potential.",
    cta: "Start Your Journey",
    gradient: "from-secondary/10 to-secondary/5",
    link: "/jobseeker-auth",
    role: "candidate",
  },
  {
    icon: Building2,
    title: "Employers",
    description: "Access untapped talent, reduce hiring costs, and build a more inclusive workforce with proven ROI.",
    cta: "Post Opportunities",
    gradient: "from-primary/10 to-primary/5",
    link: "/employer-login",
    role: "employer",
  },
  {
    icon: Heart,
    title: "Community Organisations",
    description: "Connect your participants to opportunities, share resources, and demonstrate your social impact.",
    cta: "Join Network",
    gradient: "from-secondary/10 to-secondary/5",
    link: "/community-org-auth",
    role: "community",
  },
];

export const UserPathways = () => {
  const navigate = useNavigate();

  const handlePathwayClick = (link: string) => {
    navigate(link);
  };

  return (
    <section className="py-32 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20 space-y-6">
          <h2 className="text-4xl md:text-5xl font-bold leading-tight">
            Who We <span className="text-primary">Serve</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            A comprehensive platform connecting all stakeholders in the second-chance employment ecosystem.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {pathways.map((pathway, index) => (
            <Card
              key={index}
              className={`p-8 bg-gradient-to-br ${pathway.gradient} hover:shadow-[var(--shadow-elevated)] transition-all duration-300 group hover:-translate-y-2 border-2 hover:border-primary/40 cursor-pointer`}
              onClick={() => handlePathwayClick(pathway.link)}
            >
              <div className="p-3 bg-primary/10 rounded-xl w-fit mb-5 group-hover:scale-110 transition-transform">
                <pathway.icon className="w-10 h-10 text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-3">{pathway.title}</h3>
              <p className="text-muted-foreground mb-6 min-h-[5rem] leading-relaxed">{pathway.description}</p>
              <Button 
                variant="ghost" 
                className="group/btn w-full justify-between hover:bg-primary/10"
              >
                {pathway.cta}
                <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-2 transition-transform" />
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
